export default __webpack_public_path__ + "static/benefit1Img-a6ee1e6efe78340c8291ba20d2d98300.webp";